import { EditIcon } from "@/components/icons/Icon";
import { Box, Text, Separator, Flex, IconButton } from "@chakra-ui/react";
import { FcAlarmClock } from "react-icons/fc";
import Tags from "./Tags";
import { Tag } from "@/components/ui/tag";
import { CloseButton } from "@/components/ui/close-button"
import { formatBoardDueLabel, formatBoardTimestamp } from "@/data/DateTimeUtil";
import { boardUserName } from "./BoardUsers";
import { Avatar } from "@/components/ui/avatar";
import { userService } from "@/service/UserService";
import { Tooltip } from "@/components/ui/tooltip";


const CardComponent = ({
  id,
  title,
  label,
  description,
  tags,
  assignedTo,
  organizationId,
  updatedAt,
  createdAt,
  users = [],
  laneId,
  cardColor = 'black',
  onDelete,
  onClick,
  onChange = undefined,
  className = undefined,
  cardStyle = undefined,
  showDeleteButton = false,
  t = undefined
}) => {
  const clickDelete = e => {
    onDelete()
    e.stopPropagation()
  }

  let deg = Math.random() * 4 - 2; // Generates a random number between -1 and 1
  const dueLabel = formatBoardDueLabel(label);
  const assignee = boardUserName(users, assignedTo);
  const assigneeAvatarUrl = organizationId && assignedTo ? userService.avatarUrlFrom(organizationId, assignedTo) : "";
  const updatedLabel = formatBoardTimestamp(updatedAt ?? createdAt);
  const assigneeAvatar = assignee ? (
    <Tooltip content={assignee}>
      <Avatar
        size='sm'
        bg='white'
        color={cardColor}
        borderless={false}
        borderWidth='1px'
        shadow='md'
        name={assignee}
        src={assigneeAvatarUrl}
      />
    </Tooltip>
  ) : null;

  //console.log(`id=${id}`);

  return (
    <Box style={{
      display: 'flex',
      flexDirection: 'column',
      transform: `rotate(${deg}deg)`,
    }}
      boxShadow={'lg'}
      fontFamily={'Caveat'}
      fontWeight={'bold'}
      fontSize={'1.4rem'}
      my={'10px'}
      mx={'2px'}
      pb={'2'}
      px={'1'}
      color={cardColor}
      backgroundColor={'#F4F265'}
      cursor={'pointer'}
      borderRadius={'5'}
      borderBottom='1px solid #eee'
      justifyContent='space-between'
      maxW='20rem'
    >
      <Flex align='flex-start' gap={2} pr={description ? undefined : '3.5rem'}>
        <Text flex='1' minW={0}>{title}</Text>
        {!description && assigneeAvatar}
      </Flex>
      <IconButton aria-label='Edit card' size='xs' variant='ghost' color={cardColor} onClick={(event) => {
        event.stopPropagation();
        onClick?.();
      }}
        style={{ transition: 'all 0.6s ease', position: 'absolute', top: '-1px', right: '28px' }} >
        <EditIcon />
      </IconButton>
      {showDeleteButton && <CloseButton size='sm' color={cardColor} onClick={clickDelete}
        style={{ transition: 'all 0.6s ease', position: 'absolute', top: '-1px', right: '2px' }} />}
      {description && (
        <>
          <Separator borderWidth='1px' borderColor='orange' />
          <Flex align='flex-start' gap={2}>
            <Text flex='1' minW={0} fontWeight='light' fontSize='md' whiteSpace='break-spaces'>{description}</Text>
            {assigneeAvatar}
          </Flex>
        </>
      )}
      <Flex justifyContent='space-between' flexDirection='row' gap={1} wrap='wrap'>
        <Tags tags={tags ?? []} />
      </Flex>
      {(updatedLabel || dueLabel) && (
        <Flex align='center' gap={2} mt={1} wrap='wrap'>
          {updatedLabel && (
            <Text fontWeight='normal' fontSize='xs' color='gray.700'>
              Updated {updatedLabel}
            </Text>
          )}
          {dueLabel && (
            <Tag size='md' key='Issue' variant='subtle' colorPalette='yellow' fontSize='xs' dropShadow='3px' ml='auto' startElement={<FcAlarmClock />} whiteSpace='nowrap' flexShrink={0}>
              {dueLabel}
            </Tag>
          )}
        </Flex>
      )}
    </Box>
  )
}

export default CardComponent
